var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1946_3669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 11.3132 19.7413 12.6136 19.2388 13.8268C18.7362 15.0401 17.9997 16.1425 17.0711 17.0711C16.1425 17.9997 15.0401 18.7362 13.8268 19.2388C12.6136 19.7413 11.3132 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C11.3132 0 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10ZM8.90927 11.3877C8.90826 11.3889 8.90698 11.3899 8.90551 11.3906C8.90405 11.3912 8.90245 11.3916 8.90083 11.3916C8.8992 11.3916 8.8976 11.3912 8.89614 11.3906C8.89468 11.3899 8.89339 11.3889 8.89238 11.3877C8.34975 10.6806 7.81713 9.9803 7.29452 9.28692C7.21227 9.17777 7.13267 9.09489 7.05573 9.03828C6.72781 8.79715 6.25727 8.8891 5.91809 9.08707C5.51792 9.32117 5.40439 9.80156 5.55123 10.2214C5.59376 10.3437 5.6804 10.4882 5.81113 10.6549C6.56924 11.6229 7.32642 12.6007 8.08266 13.5884C8.18869 13.7269 8.28814 13.8223 8.38103 13.8746C8.89426 14.1631 9.45299 13.9308 9.78561 13.496C11.2609 11.5669 12.7372 9.64143 14.2147 7.71955C14.5637 7.2659 14.674 6.58379 14.1354 6.21458C13.8173 5.9969 13.4669 5.96281 13.0841 6.11231C12.9527 6.16345 12.8078 6.26009 12.7228 6.37127C11.4502 8.04325 10.1791 9.71539 8.90927 11.3877Z",
    fill: "#35C994"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1946_3669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.0aa50c7aeeb8d111b3721a29e88fc37e.svg";
export { ForwardRef as ReactComponent };